import React, { useEffect, useState } from 'react';
import AuthForms from './AuthForms';
import { profileService } from '../../services/profileService';

interface LoginPageProps {
  initialMode?: 'login' | 'register';
}

const LoginPage: React.FC<LoginPageProps> = ({ initialMode = 'login' }) => {
  const [loading, setLoading] = useState<boolean>(true);
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const isAuth = await profileService.isAuthenticated();
        setIsAuthenticated(isAuth);
        
        // If already authenticated, redirect to dashboard
        if (isAuth) {
          window.location.href = '/';
        }
      } catch (error) {
        console.error('Error checking authentication:', error);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-500"></div>
      </div>
    );
  }

  if (isAuthenticated) {
    return (
      <div className="max-w-md mx-auto mt-16 px-4">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="text-center">
            <h2 className="text-2xl font-bold text-gray-900 mb-4">Already Signed In</h2>
            <p className="text-gray-600 mb-4">You are already signed in.</p>
            <a
              href="/"
              className="inline-flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Go to Dashboard
            </a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <h1 className="text-center text-3xl font-extrabold text-gray-900">
          Triple Point Trading Strategy
        </h1>
        <p className="mt-2 text-center text-sm text-gray-600">
          Sign in to access your trading dashboard and portfolio
        </p>
      </div>

      <div className="mt-8">
        <AuthForms redirectUrl="/" initialMode={initialMode} />
      </div>
    </div>
  );
};

export default LoginPage; 